import { classnames } from '@tailwindcss-classnames';

export const sectionWrapper = classnames('py-6', 'md:py-12', 'xl:py-16');

export default sectionWrapper;
